import React from 'react';
import { Typography } from '@material-ui/core';
import AppLoader from '../../../basic/AppLoader';

const DeploymentStatus = (props) => {
  return (
    <>
      <Typography align='center' variant='h5'>
        Click deploy to complete the process!
      </Typography>
      <Typography align='center' variant='h6'>
        The eshop customers will not see the product immediately.
        <br />
        You will have to manually publish it.
      </Typography>
      {props.loading && <AppLoader />}
    </>
  );
};

export default DeploymentStatus;
